/* global localStorage */

import { LoginResBody, TokenPayload } from "../../types/auth.types";

const TOKEN = "__TOKEN__";

class AuthStorage {
  get token(): TokenPayload | null {
    const value = localStorage.getItem(TOKEN);
    if (!value) return null;

    return JSON.parse(value);
  }

  set token(value: LoginResBody) {
    const payload: TokenPayload = {
      access_token: value.access_token,
      refresh_token: value.refresh_token,
      expires_at: value.expires_in,
    };

    localStorage.setItem(TOKEN, JSON.stringify(payload));
  }

  removeToken(): void {
    localStorage.removeItem(TOKEN);
  }
}

export const authStorage = new AuthStorage();

export default authStorage;
